// Add Category
import { Component, ViewChild } from '@angular/core';
import { DropdownQuestion } from 'src/app/misc/component/dynamic-form/question-dropdown';
import { TextboxQuestion } from 'src/app/misc/component/dynamic-form/question-textbox';
import { TreeSelectQuestion } from 'src/app/misc/component/dynamic-form/question-treeselect';
import {
  Message
} from 'primeng/api';
import { QuestionBase } from 'src/app/misc/component/dynamic-form/question-base';
import { DataService } from 'src/app/services/data.service';
import { DynamicFormComponent } from 'src/app/misc/component/dynamic-form/dynamic-form.component';
import { TextAreaQuestion } from 'src/app/misc/component/dynamic-form/question-textarea';
import {
  link,
  breadcrumb,
  stat
} from 'src/app/admin/layout/header/header.component';
import { Router } from '@angular/router';

import { TranslatorPipe } from 'src/app/services/translator.pipe';


@Component({
  selector: 'app-add-category',
  templateUrl: './add-category.component.html',
  styleUrls: ['./add-category.component.scss']
})
export class AddCategoryComponent {

  @ViewChild(DynamicFormComponent) DynamicFormComponent:
    | DynamicFormComponent
    | any;

  questions: QuestionBase<string>[] = [];
  trainingType: any[] = [];
  stats: stat[] = [];
  messages: Message[] = [];

  header = 'Training Requests';
  links: link[] = [

    {
      name: 'Training Type',
      icon: 'pi pi-file-edit',
      link: '/training/type',
      visible: true,
    },

  ];
  breadcrumbs: breadcrumb[] = [
    { name: 'Training Request', link: '/admin/data' },
  ];

  translator:TranslatorPipe = new TranslatorPipe()

  constructor(private dataService: DataService,private router: Router) {}
  
  ngOnInit() {
    this.getTrainingTypes();
  }
  translate(key:string) {
    let translator:TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  private async getTrainingTypes(): Promise<void> {
    let res = await this.dataService.postData('training-type/get', {
      
      active: true,
    });
    if (res.error) {
      return;
    }
    this.trainingType = res.data.map((item: any) => {
      return {
        _id: item._id,
        label: item.arabic,
        icon: `pi pi-${item.icon}`,
        value: item._id,
      };
    });
    this.makeQuestion();
  }
  makeQuestion() {
    this.questions = [
      new TextboxQuestion({
        key: 'topic',
        label: 'Topic',
        required: true,
        order: 1,
        icon: 'pi pi-file',
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new DropdownQuestion({
        key: 'type',
        label: 'Training Type',
        required: true,
        options: this.trainingType,
        filter: true,
        order: 2,
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new TextAreaQuestion({
        key: 'description',
        label: 'Description',
        required: true,
        order: 4,
        className: 'col-md-12 col-sm-12 col-12',
      }),
    ];
  }

  receiveData = async ($event: any) => {
    try {
      let data = $event;
      let res = await this.dataService.postData('training-req/', data);
      if (res.error) { this.messages = [{ severity: 'error',  summary: this.translate('error'), detail: res.msg }];
        return;
      }
      else{ 
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.DynamicFormComponent.resetForm();
      this.router.navigate(['/training/view-requests']);
    }
    } catch (error) {
      //error toast bnana h user friendly msg dikhy user ko .. 
    }
  };
}